(function() {
    'use strict';

    angular
        .module('app')
        .directive('contenteditable', contenteditable);

    contenteditable.$inject = ['$window'];
    
    function contenteditable ($window) {
        // Usage:
        //     <contenteditable></contenteditable>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'A',
            require: 'ngModel'
        };
        return directive;

        function link(scope, element, attrs, ngModel) {
            function read() {
                var html = $(element).html();
                html = html.replace(/&nbsp;/g, "\u00a0");
                ngModel.$setViewValue(html);
            }

            ngModel.$render = function () {
                element.html(ngModel.$viewValue || "");
            };

            element.bind("blur keyup change", function () {
                scope.$apply(read);
            });
        }
    }

})();